
import { DOMAttr, HTMLAttr, CSSProp } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { displayAlertOnError, errorFilesNotification } from "./Notifications.js";
import { UICommandType, currentProj_, UserData, TTMsg, readOnlyBaseline_, savedSheetIsOutOfDate_, Model, sheet_, Msg } from "../Model/ModelType.js";
import * as react_1 from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { confirmationPopup, closablePopup, choicePopup, getMemorySetup, dynamicConfirmationPopup } from "../DrawBlock/PopupHelpers.js";
import { getSlice, concat as concat_1, find, mapIndexed, item as item_1, tryFindIndex, insertAt, truncate, tryHead, reverse, tryFind as tryFind_1, maxBy, tail, head, contains, append, sumBy, max, isEmpty, filter as filter_1, choose, last, sortBy, tryPick, cons, length, empty as empty_1, map as map_3, singleton, exists, fold, ofArray, collect } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { keysOf } from "./Style.js";
import { ShortcutId } from "../Common/KeyTypes.js";
import { StringModule_ReplaceChar, StringModule_StartsWithLetter, StringModule_Concat } from "../Common/EEExtensions.js";
import { singleton as singleton_1, append as append_1, delay, toList as toList_2, collect as collect_1, forAll, takeWhile, filter, map as map_2 } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { isLetterOrDigit } from "../fable_modules/fable-library-js.5.13.0/Char.js";
import { toFail, concat, printf, toText } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { DrawModelType_SheetT_Model__Model_GetCanvasState, DrawModelType_SheetT_Model__Model_ChangeLabel } from "../DrawBlock/Sheet.js";
import { DrawModelType_SheetT_KeyboardMsg, DrawModelType_SymbolT_Msg, DrawModelType_SheetT_symbol_, DrawModelType_SheetT_Msg, DrawModelType_BusWireT_Msg } from "../Model/DrawModelType.js";
import { toList as toList_1, map as map_4, tryFind, ofList, empty, FSharpMap__get_Item, containsKey } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { warn } from "../Shared/Log.js";
import { JSDiagramMsg, loadedComponentOf_, loadedComponentIsOutOfDate_, CCForm, LoadedComponent, Project, Connection, Memory1, InitMemData, SheetInfo as SheetInfo_1, Component } from "../Common/CommonTypes.js";
import { Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Set_op_HatEquals_Z147477F8 } from "../Common/Optics.js";
import { Optic_Set_op_HatEquals_Z147477F8 as Optic_Set_op_HatEquals_Z147477F8_1, Compose_Lens_op_GreaterMinusGreater_Z15C92E89 as Compose_Lens_op_GreaterMinusGreater_Z15C92E89_1, Optic_Map, Optic_Map_op_HatPercent_Z1462312A, Compose_Lens, Optic_Set } from "../Common/Optics.js";
import { DrawModelType_SymbolT_component_, DrawModelType_SymbolT_symbolOf_ } from "../Model/DrawModelType.js";
import { saveStateToFileExperimental, persistFileToExternalStorageAsync, inspectProjectDirectory, loadAllComponentFiles, normalisePath, createEmptyDgmFile, unlink, exists as exists_1, ensureDirectory, tryLoadComponentFromPath, pathJoin, latestBackupFileData, dirName, backupDirOf, baseName as baseName_1, pathWithoutExtension, removeFileWithExtn, readFilesFromDirectoryWithExtn, removeExtn, initialiseMem, makeLoadedComponentFromCanvasData } from "../Interface/FilesIO.js";
import { minute, hour, toShortDateString, op_Subtraction, compare as compare_1, now } from "../fable_modules/fable-library-js.5.13.0/Date.js";
import { input } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option, IInputType } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { debugLevel, getTextEventValue } from "../Interface/JSHelpers.js";
import { compare } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { dataProblemAtWidths } from "../Common/MemoryData.js";
import { currentSheetIsOutOfDate, updateLdCompsWithCompOpt, designWithSheet, getSavedWaveInfo, openSheetIsReadOnly, getCurrFile, initWSModel, loadWSModelFromSavedWaveInfo, syncArrayTextFor, tryGetLoadedComponents, CSSGridPos_$reflection, memoryWidthsInDesign } from "./ModelHelpers.js";
import { orElse, defaultArg, value as value_5 } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { list as list_19, menu as menu_1, Item_Option, Item_li } from "../fable_modules/Fulma.3.0.0/Components/Menu.fs.js";
import { Exception, compare as compare_2, curry2, stringHash, comparePrimitives, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { label as label_1 } from "../fable_modules/Fulma.3.0.0/Elements/Form/Label.fs.js";
import { item, right, left, Level_Option, level } from "../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { Option as Option_1, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { dbg, error, warn as warn_1 } from "../Shared/Log.js";
import { Record } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { record_type, option_type, int32_type, list_type, string_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { sheetFilePath, tryLoadLibraryProject, libraryPathIsEditable, writeSheetFileAt, sheetExtension, unusedLibrarySheets, writeSheetFile, isLibrarySheet } from "../Interface/ComponentLibraries.js";
import { List_groupBy, List_distinct, List_distinctBy } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { iterate, remove, filter as filter_2, union, difference, ofSeq, toList, count, ofList as ofList_1, empty as empty_2, add, contains as contains_1 } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { MapModule_KeysA } from "../Common/EEExtensions.js";
import { parseDiagramSignatureFor, tidyParamSlots, compareCanvas, compareIOs } from "../Simulator/CanvasExtractor.js";
import { totalHours } from "../fable_modules/fable-library-js.5.13.0/TimeSpan.js";
import { bindMissingInstanceParams } from "../Common/ParameterAnalysis.js";
import { RegenerateIds_admitDesign } from "../Common/Helpers.js";
import { helpText } from "./UIPopups.js";
import { Confirm_idsConverted } from "../Common/AppMessages.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";

export const Constants_minGoodAppWidth = 1250;

export const Constants_minAppWidth = 1060;

export const Constants_typicalAppWidth = 1600;

export const Constants_numberOfRecentProjects = 5;

export const Constants_maxDisplayedPathLengthInRecentProjects = 60;

export const Constants_largeScreenCanvasWidth = 1000;

export const Constants_maxNumPathChars = 25;

export const Constants_minNumPathChars = 7;

export const Constants_numCharsHidePath = 10;

export const Constants_boldStyle = new CSSProp(/* FontWeight */ 165, ["bold"]);

export const Constants_redColor = new CSSProp(/* Color */ 103, ["red"]);

export const Constants_blueColor = new CSSProp(/* Color */ 103, ["blue"]);

export const Constants_greenColor = new CSSProp(/* Color */ 103, ["green"]);

export function displayFileErrorNotification(err, dispatch) {
    return dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(err)]));
}

export function warnAppWidth(dispatch, afterFun) {
    const bSpan = (txt_1) => {
        const props = [["style", {
            fontWeight: "bold",
        }]];
        return react_1.createElement("span", keyValueList(props, 1), txt_1);
    };
    if (self.innerWidth < Constants_minGoodAppWidth) {
        dynamicConfirmationPopup("Issie Window Size Warning", "Continue", (model) => {
            let children_2, children_6, children_8, children_10;
            const appWidth_1 = model.WindowWidth;
            const children_12 = collect((s_13) => ofArray([s_13, react_1.createElement("br", {})]), ofArray([(children_2 = ["The issie app window is currently ", bSpan(`${appWidth_1} pixels`), " in width."], react_1.createElement("div", {}, ...children_2)), react_1.createElement("div", {}, "Issie works best with a width of > 1250 pixels, and typically 1600 pixels."), (children_6 = ["Issie UI will be ", bSpan("slightly degraded"), " when width < 1150 pixels."], react_1.createElement("div", {}, ...children_6)), (children_8 = ["Issie UI will be ", bSpan("severely degraded"), " when width < 1050 pixels."], react_1.createElement("div", {}, ...children_8)), (children_10 = ["App Zoom-out ", keysOf(ShortcutId.ScAppZoomOut), " or Zoom-in ", keysOf(ShortcutId.ScAppZoomIn), " will increase or decrease window width at any time using Issie."], react_1.createElement("div", {}, ...children_10)), (appWidth_1 < 1250) ? bSpan("You are advised to Zoom Out now.") : ""]));
            return react_1.createElement("div", {}, ...children_12);
        }, afterFun, dispatch);
    }
    else {
        afterFun();
    }
}

export function extractLabelBase(text) {
    return StringModule_Concat("", map_2((ch_3) => ch_3, filter((ch_1) => {
        const ch_2 = ch_1;
        return isLetterOrDigit(ch_2) ? true : (ch_2 === "_");
    }, takeWhile((ch) => (ch !== "("), text.toLocaleUpperCase().split("")))));
}

export function formatLabelAsBus(width, text) {
    const text$0027 = extractLabelBase(text);
    if (width === 1) {
        return text$0027;
    }
    else {
        const arg = text$0027.toLocaleUpperCase();
        const arg_1 = (width - 1) | 0;
        return toText(printf("%s(%d:%d)"))(arg)(arg_1)(0);
    }
}

export function formatLabelFromType(compType, text) {
    const text$0027 = extractLabelBase(text);
    let matchResult;
    switch (compType.tag) {
        case 0: {
            if (compType.fields[0] === 1) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        case 1: {
            if (compType.fields[0] === 1) {
                matchResult = 0;
            }
            else {
                matchResult = 1;
            }
            break;
        }
        default:
            matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return text$0027;
        default:
            return text$0027;
    }
}

export function formatLabel(comp, text) {
    return formatLabelFromType(comp.Type, text);
}

export function setComponentLabel(model, sheetDispatch, comp, text) {
    DrawModelType_SheetT_Model__Model_ChangeLabel(model.Sheet, sheetDispatch, comp.Id, text.toLocaleUpperCase());
    if (comp.Type.tag === 3) {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [DrawModelType_BusWireT_Msg.BusWidths]));
    }
}

export function updateSymbolRAMs(ramCheck, sModel) {
    return fold((sModel_1, comp) => {
        let matchValue, l;
        const cId = comp.Id;
        if (containsKey(cId, sModel_1.Symbols)) {
            const model = sModel_1;
            const compId = cId;
            const comp_1 = FSharpMap__get_Item(model.Symbols, compId).Component;
            const newComp = new Component(comp_1.Id, (matchValue = comp_1.Type, (matchValue.tag === 41) ? comp.Type : ((matchValue.tag === 42) ? comp.Type : ((matchValue.tag === 40) ? comp.Type : ((matchValue.tag === 39) ? comp.Type : ((warn(concat("improper use of WriteMemoryType on ", comp_1.Label, " ignored")), comp_1.Type)))))), comp_1.Label, comp_1.InputPorts, comp_1.OutputPorts, comp_1.X, comp_1.Y, comp_1.H, comp_1.W, comp_1.SymbolInfo, comp_1.SlotInfo);
            return Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, (l = DrawModelType_SymbolT_symbolOf_(compId), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_component_)(l)))(newComp)(model);
        }
        else {
            return sModel_1;
        }
    }, sModel, ramCheck);
}

export function loadComponentWithRAMChanges(newCS_, newCS__1, savedWaveSim, ldc, model) {
    const newCS = [newCS_, newCS__1];
    const sheetInfo = new SheetInfo_1(ldc.Form, ldc.Description, ldc.LCParameterSlots, ldc.IsTopSheet, ldc.ArrayInfo);
    const patternInput = makeLoadedComponentFromCanvasData(newCS[0], newCS[1], ldc.FilePath, now(), savedWaveSim, sheetInfo);
    return Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89_1(Compose_Lens.Lens, DrawModelType_SheetT_symbol_)(sheet_))((sModel) => updateSymbolRAMs(patternInput[1], sModel))(model);
}

/**
 * temporary shim for compatibility while dispatch is still being used.
 */
export function raiseFileNotification(dispatch, msg) {
    if (msg == null) {
    }
    else {
        dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(msg)]));
    }
}

/**
 * maybe no longer needed...
 */
export function fileEntryBox(files, fName, dialog, dispatch) {
    const inputValidate = (text) => !((((text === "") ? true : exists((y) => (text === y), files)) ? true : !forAll((ch) => {
        const ch_1 = ch;
        return isLetterOrDigit(ch_1) ? true : (ch_1 === "_");
    }, text.split(""))) ? true : !StringModule_StartsWithLetter(text));
    const patternInput = getMemorySetup(dialog, 1);
    return input(ofArray([new Option(/* Type */ 1, [IInputType.Text$]), new Option(/* Props */ 15, [singleton(["style", {
        marginLeft: "2em",
    }])]), new Option(/* DefaultValue */ 10, [fName]), new Option(/* Placeholder */ 12, ["Enter file name"]), new Option(/* Color */ 2, [inputValidate(fName) ? Color_IColor.IsSuccess : Color_IColor.IsDanger]), new Option(/* OnChange */ 13, [(arg) => {
        const newName = getTextEventValue(arg);
        dispatch(new Msg(/* SetPopupDialogMemorySetup */ 68, [[patternInput[0], patternInput[1], inputValidate(newName) ? (new InitMemData(/* ToFile */ 2, [newName])) : (new InitMemData(/* ToFileBadName */ 3, [newName])), undefined]]));
    }])]));
}

/**
 * Make a poup with menu to view and select a memory data source
 */
export function makeSourceMenu(model, updateMem, cid, dispatch, modelCurrent) {
    const dialog = modelCurrent.PopupDialogData;
    const projOpt = model.CurrentProj;
    const matchValue = dialog.MemorySetup;
    if (matchValue != null) {
        matchValue[3];
        matchValue[1];
        matchValue[0];
        const mem = matchValue[2];
        const onSelect = (key_1) => {
            const patternInput = getMemorySetup(dialog, 1);
            const n2_1 = patternInput[1] | 0;
            const n1_1 = patternInput[0] | 0;
            dispatch(new Msg(/* SetPopupDialogMemorySetup */ 68, [[n1_1, n2_1, key_1, (key_1.tag === 1) ? key_1.fields[0] : undefined]]));
            let matchResult, p, s;
            if (key_1.tag === 1) {
                if (projOpt != null) {
                    matchResult = 0;
                    p = projOpt;
                    s = key_1.fields[0];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const mem_2 = initialiseMem(new Memory1(new InitMemData(/* FromFile */ 1, [s]), n1_1, n2_1, empty({
                        Compare: (x, y) => (compare(x, y) | 0),
                    }), undefined), p.ProjectPath);
                    if (mem_2.tag === 1) {
                        dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(mem_2.fields[0])]));
                    }
                    else {
                        const mem$0027 = mem_2.fields[0];
                        const matchValue_2 = dataProblemAtWidths(memoryWidthsInDesign(model, cid, mem$0027), mem$0027.Data);
                        if (matchValue_2 != null) {
                            dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(`'${s}.ram' does not fit this memory: ${matchValue_2}.`)]));
                        }
                        else {
                            updateMem(cid, (_arg) => mem$0027);
                        }
                    }
                    break;
                }
                case 1: {
                    updateMem(cid, (mem_3) => (new Memory1(InitMemData.FromData, mem_3.AddressWidth, mem_3.WordWidth, mem_3.Data, mem_3.Comments)));
                    break;
                }
            }
        };
        const existingFiles = map_3((Item) => (new InitMemData(/* FromFile */ 1, [Item])), map_3((arg) => value_5(removeExtn(".ram", arg)), readFilesFromDirectoryWithExtn(dialog.ProjectPath, ".ram")));
        const printSource = (inList, key_2) => {
            switch (key_2.tag) {
                case 0:
                    return singleton("Unlink and use data from memory viewer/editor");
                case 1:
                    return singleton(concat("Link memory to file ", key_2.fields[0], ".ram"));
                default:
                    return empty_1();
            }
        };
        const noFileItem = Item_li(ofArray([new Item_Option(/* IsActive */ 0, [equals(mem, InitMemData.FromData)]), new Item_Option(/* OnClick */ 3, [(_arg_2) => {
            onSelect(InitMemData.FromData);
        }])]), printSource(true, InitMemData.FromData));
        const modalMessageWithRamFiles = "Use this menu to change how the memory initial data is sourced. You can link data to the contents of an external file in your project folder, or unlink it. Unlinked data can be edited from the properties panel.";
        const modalMessageNoRamFiles = "You cannot now link this file because your project directory has no .ram files. Add a .ram file (with data in the format you can see if you write a memory) to your project directory, then return to this menu to link it.";
        const patternInput_1 = (length(existingFiles) > 0) ? [modalMessageWithRamFiles, cons(noFileItem, map_3((key_3) => {
            let mSetup;
            const react = printSource(true, key_3);
            return Item_li(ofArray([new Item_Option(/* IsActive */ 0, [equals(key_3, (mSetup = dialog.MemorySetup, (mSetup == null) ? InitMemData.FromData : mSetup[2]))]), new Item_Option(/* OnClick */ 3, [(_arg_1) => {
                onSelect(key_3);
            }])]), react);
        }, existingFiles))] : ((mem.tag === 1) ? ["You have linked this component to file \'{s}\' which does not exist or is badly formatted. Please either correct the file or remove the link.", singleton(noFileItem)] : [modalMessageNoRamFiles, singleton(noFileItem)]);
        const children_2 = [label_1(empty_1(), singleton(patternInput_1[0])), react_1.createElement("br", {}), react_1.createElement("br", {}), menu_1(empty_1(), singleton(list_19(empty_1(), patternInput_1[1]))), level(singleton(new Level_Option(/* Props */ 0, [singleton(["style", {
            width: "100%",
            paddingTop: "20px",
        }])])), ofArray([left(empty_1(), empty_1()), right(empty_1(), singleton(item(empty_1(), singleton(button(ofArray([new Option_1(/* Color */ 0, [Color_IColor.IsSuccess]), new Option_1(/* OnClick */ 18, [(_arg_3) => {
            dispatch(Msg.ClosePopup);
        }])]), singleton("Change Source"))))))]))];
        return react_1.createElement("div", {}, ...children_2);
    }
    else {
        warn_1("no memory setup in the dialog data");
        return react_1.createElement("div", {});
    }
}

/**
 * Node in the sheet tree, child nodes correspond to custom components in sheet.
 */
export class SheetTree extends Record {
    constructor(LabelPath, SheetName, SheetPath, SheetAccessPath, BreadcrumbName, Size, Depth, SubSheets, GridArea) {
        super();
        this.LabelPath = LabelPath;
        this.SheetName = SheetName;
        this.SheetPath = SheetPath;
        this.SheetAccessPath = SheetAccessPath;
        this.BreadcrumbName = BreadcrumbName;
        this.Size = (Size | 0);
        this.Depth = (Depth | 0);
        this.SubSheets = SubSheets;
        this.GridArea = GridArea;
    }
}

export function SheetTree_$reflection() {
    return record_type("MenuHelpers.SheetTree", [], SheetTree, () => [["LabelPath", list_type(string_type)], ["SheetName", string_type], ["SheetPath", list_type(string_type)], ["SheetAccessPath", list_type(int32_type)], ["BreadcrumbName", string_type], ["Size", int32_type], ["Depth", int32_type], ["SubSheets", list_type(SheetTree_$reflection())], ["GridArea", option_type(CSSGridPos_$reflection())]]);
}

/**
 * Keyed by LabelPath, while the wave selector keys its nodes by SheetPath: a node stands for
 * every instance of its sheet at that point in the tree, so it has no one label path.
 */
export function SheetTree__lookupPath_7F866359(this$, path) {
    const lookup = (sheet) => {
        if (equals(sheet.LabelPath, path)) {
            return sheet;
        }
        else {
            return tryPick(lookup, sheet.SubSheets);
        }
    };
    return lookup(this$);
}

export const subSheets_ = [(a) => a.SubSheets, (s) => ((a_1) => (new SheetTree(a_1.LabelPath, a_1.SheetName, a_1.SheetPath, a_1.SheetAccessPath, a_1.BreadcrumbName, a_1.Size, a_1.Depth, s, a_1.GridArea)))];

export const breadcrumbName_ = [(a) => a.BreadcrumbName, (s) => ((a_1) => (new SheetTree(a_1.LabelPath, a_1.SheetName, a_1.SheetPath, a_1.SheetAccessPath, s, a_1.Size, a_1.Depth, a_1.SubSheets, a_1.GridArea)))];

/**
 * One custom component instance on a sheet's canvas. The field names are prefixed because F#
 * resolves an unannotated record field to the LAST type declaring it: `Label`, `Id` and `Sheet`
 * would each capture uses meant for Component and for the Elmish Model, in every file compiled
 * after this one.
 */
export class SheetInstance extends Record {
    constructor(InstLabel, InstId, InstSheet) {
        super();
        this.InstLabel = InstLabel;
        this.InstId = InstId;
        this.InstSheet = InstSheet;
    }
}

export function SheetInstance_$reflection() {
    return record_type("MenuHelpers.SheetInstance", [], SheetInstance, () => [["InstLabel", string_type], ["InstId", int32_type], ["InstSheet", string_type]]);
}

function nameChildrenUniquely(subSheets) {
    return sortBy((subs) => subs.BreadcrumbName, map_3((subsheet) => {
        let value;
        return (exists((subs$0027) => {
            if (subsheet.SheetName === subs$0027.SheetName) {
                return !equals(subsheet.LabelPath, subs$0027.LabelPath);
            }
            else {
                return false;
            }
        }, subSheets) ? ((value = concat(subsheet.SheetName, ":", last(subsheet.LabelPath)), Optic_Set_op_HatEquals_Z147477F8_1(Optic_Set.Set$, breadcrumbName_)(value))) : ((x) => x))(subsheet);
    }, subSheets), {
        Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
    });
}

export function foldOverTree(isSubSheet, folder, tree, model) {
    return fold((model_2, tree_1) => foldOverTree(false, folder, tree_1, model_2), folder(isSubSheet, tree, model), tree.SubSheets);
}

/**
 * What is directly inside each sheet of the project: one pass over each canvas, and so a cost
 * that is the design's own size whatever that design expands to.
 * 
 * showLibrarySheet: a library sheet it answers false for is left out, and so are the instances
 * that would put it inside someone else - a library component is one thing, not a sheet with
 * innards. It has to be decided here rather than by filtering the project first: the shapes are
 * read off each sheet's canvas, so a sheet removed from LoadedComponents still leaves its
 * instance naming it, with nothing to find under that name.
 * 
 * A predicate rather than one flag for the lot, because a library component the user has asked
 * to look inside appears in the Sheets menu while the rest of the library stays hidden.
 * 
 * The sheets are given as a list rather than as a project, because not every hierarchy is drawn
 * from the project: the wave selector draws the design that was SIMULATED, which the simulation
 * carries as a list of exactly the sheets it needed.
 */
export function getSheetShapes(showLibrarySheet, ldcs) {
    const ldcMap = ofList(map_3((ldc) => [ldc.Name, ldc], ldcs), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const hidden = (sheet) => {
        let option_1;
        if (!showLibrarySheet(sheet)) {
            return defaultArg((option_1 = tryFind(sheet, ldcMap), (option_1 != null) ? isLibrarySheet(option_1) : undefined), false);
        }
        else {
            return false;
        }
    };
    return ofList(map_3((ldc_3) => [ldc_3.Name, choose((comp) => {
        const matchValue = comp.Type;
        let matchResult, ct_1;
        if (matchValue.tag === 26) {
            if (!hidden(matchValue.fields[0].Name)) {
                matchResult = 0;
                ct_1 = matchValue.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return new SheetInstance(comp.Label, comp.Id, ct_1.Name);
            default:
                return undefined;
        }
    }, ldc_3.CanvasState[0])], filter_1((ldc_2) => !hidden(ldc_2.Name), ldcs)), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    });
}

/**
 * Build the part of a hierarchy that is going to be looked at.
 * 
 * `expand` is asked of each node's SheetPath: a node it says false to comes back as a leaf and
 * nothing below it is built at all. That is what lets a design many routes reach one sheet in be
 * drawn without being walked, since the drawn tree is then the only tree there is.
 * `fun _ -> true` builds the whole thing, which is what the Sheets menu asks for.
 * 
 * allInstances = false collapses several instances of one sheet inside one parent into one node,
 * dropping the others BEFORE their subtrees are built rather than after. Instances of a sheet
 * expand identically - same children, same depth - so this is the same tree; what it is not is
 * the same amount of work.
 * 
 * A sheet reached from inside itself is not descended into. The guard is on the ancestor path, so
 * the shapes may name each other in a cycle and this still terminates.
 */
export function materialiseTree(expand, allInstances, shapes, root) {
    const node = (ancestors, sheet, sheetPath, labelPath, accessPath) => {
        let instances_1;
        const leaf = (subs) => {
            const Depth = (isEmpty(subs) ? 0 : (1 + max(map_3((s) => (s.Depth | 0), subs), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            }))) | 0;
            return new SheetTree(labelPath, sheet, sheetPath, accessPath, sheet, sumBy((sub) => (sub.Size | 0), subs, {
                GetZero: () => 0,
                Add: (x_1, y_1) => ((x_1 + y_1) | 0),
            }) + 1, Depth, subs, undefined);
        };
        const matchValue = tryFind(sheet, shapes);
        if (matchValue != null) {
            if (!expand(sheetPath)) {
                return leaf(empty_1());
            }
            else {
                const instances = matchValue;
                return leaf(nameChildrenUniquely(map_3((inst_2) => node(cons(inst_2.InstSheet, ancestors), inst_2.InstSheet, append(sheetPath, singleton(inst_2.InstSheet)), append(labelPath, singleton(inst_2.InstLabel)), cons(inst_2.InstId, accessPath)), (instances_1 = filter_1((inst) => !contains(inst.InstSheet, ancestors, {
                    Equals: (x_2, y_2) => (x_2 === y_2),
                    GetHashCode: (x_2) => (stringHash(x_2) | 0),
                }), instances), allInstances ? instances_1 : List_distinctBy((inst_1) => inst_1.InstSheet, instances_1, {
                    Equals: (x_3, y_3) => (x_3 === y_3),
                    GetHashCode: (x_3) => (stringHash(x_3) | 0),
                })))));
            }
        }
        else {
            return leaf(empty_1());
        }
    };
    return node(empty_1(), root, singleton(root), empty_1(), empty_1());
}

/**
 * The sheets that more than one route from the root reaches, and which therefore appear more than
 * once in its hierarchy. Worked out from the design graph - each sheet's parents are counted, not
 * its occurrences - so a design whose expansion is astronomical still costs its own size.
 * 
 * Everything below such a sheet is one too: a sheet inside a sheet that appears twice appears
 * twice itself, however singular its own parent is.
 */
export function multiPathSheets(shapes, root) {
    const childrenOf = (sheet) => {
        const matchValue = tryFind(sheet, shapes);
        if (matchValue != null) {
            return List_distinct(map_3((inst) => inst.InstSheet, matchValue), {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            });
        }
        else {
            return empty_1();
        }
    };
    const reach = (seen, sheet_1) => {
        if (contains_1(sheet_1, seen)) {
            return seen;
        }
        else {
            const list_2 = childrenOf(sheet_1);
            return fold(reach, add(sheet_1, seen), list_2);
        }
    };
    const reachable = reach(empty_2({
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), root);
    const seed = ofList_1(map_3((tuple_2) => tuple_2[0], filter_1((tupledArg_1) => {
        const parents_1 = ofList_1(map_3((tuple_1) => tuple_1[1], tupledArg_1[1]), {
            Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
        });
        if (count(parents_1) > 1) {
            return true;
        }
        else {
            return contains_1(tupledArg_1[0], parents_1);
        }
    }, List_groupBy((tuple) => tuple[0], filter_1((tupledArg) => contains_1(tupledArg[0], reachable), collect((parent) => map_3((child) => [child, parent], childrenOf(parent)), toList(reachable))), {
        Equals: (x_2, y_2) => (x_2 === y_2),
        GetHashCode: (x_2) => (stringHash(x_2) | 0),
    }))), {
        Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
    });
    const spread = (found_mut, frontier_mut) => {
        spread:
        while (true) {
            const found = found_mut, frontier = frontier_mut;
            if (!isEmpty(frontier)) {
                const fresh = filter_1((child_3) => {
                    if (contains_1(child_3, reachable)) {
                        return !contains_1(child_3, found);
                    }
                    else {
                        return false;
                    }
                }, childrenOf(head(frontier)));
                found_mut = fold((found_1, child_4) => add(child_4, found_1), found, fresh);
                frontier_mut = append(fresh, tail(frontier));
                continue spread;
            }
            else {
                return found;
            }
            break;
        }
    };
    return spread(seed, toList(seed));
}

/**
 * Get the subsheet tree for all sheets in the current project.
 * Returns a map from sheet name to tree of SheetTree nodes.
 * Every sheet is a root here and every node is built: callers that draw one hierarchy, and that
 * can leave part of it unopened, should use getSheetShapes and materialiseTree directly.
 */
export function getSheetTreesFiltered(showLibrarySheet, allowAllInstances, p) {
    const shapes = getSheetShapes(showLibrarySheet, p.LoadedComponents);
    return map_4((sheet, _arg) => materialiseTree((_arg_1) => true, allowAllInstances, shapes, sheet), shapes);
}

/**
 * Get the subsheet tree for all sheets in the current project, library sheets included.
 */
export function getSheetTrees(allowAllInstances, p) {
    return getSheetTreesFiltered((_arg) => true, allowAllInstances, p);
}

/**
 * Which library sheets the Sheets menu and the design hierarchy show: none, unless the developer
 * toggle is on, or the user has asked to look inside that particular component.
 */
export function librarySheetsShown(model, sheet) {
    if (model.ShowLibrarySheets) {
        return true;
    }
    else {
        return contains_1(sheet, model.OpenedLibrarySheets);
    }
}

/**
 * Which sheet a project opens at.
 * 
 * The most recently saved sheet says what the user was WORKING ON; it is rarely what they want to
 * look at first. A subsheet opened on its own is a block out of context - the design it belongs to
 * is not on screen, its parameters show whatever its own defaults give, and the first thing anyone
 * does is climb back up. So the timestamp picks the DESIGN, and the design is opened at its top.
 * 
 * The top is the highest sheet EVERY route to the last-saved one passes through. Where the project
 * is one tree, which is nearly all of them, that is simply its root. Where two roots both reach the
 * sheet it belongs to two designs and there is no saying which was meant, so the answer is the
 * highest sheet they have in common on the way to it - which may be the sheet itself.
 * 
 * Note that a sheet reached by two routes is not by itself an ambiguity: one design using a block
 * twice still has one root, and that root is still what opens. Climbing while there was a single
 * PARENT would stop at such a sheet and open a block out of context, which is the thing this
 * exists to avoid.
 * 
 * Library sheets are left out of the graph entirely. A library component is one thing rather than
 * a sheet with innards, so it is neither a design to open nor a route that makes one ambiguous.
 * 
 * Only a sheet the user made is a candidate for "last worked on" - a generated or protected sheet
 * carries a timestamp from something the user did not do - but any of them can be climbed through,
 * since a design is opened at its top whoever wrote the sheets in between.
 * 
 * The cost is a walk of the design graph per sheet above the one chosen, which is the project's
 * own size squared and not its expansion - and it is paid once, while a project is being opened.
 * 
 * None only for a project with no user sheets at all.
 */
export function sheetOpenedOnLoad(ldcs) {
    let sheet_2, above, roots, dominators;
    const userSheets = filter_1((ldc) => {
        const matchValue = ldc.Form;
        let matchResult;
        if (matchValue == null) {
            matchResult = 0;
        }
        else if (matchValue.tag === 0) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return true;
            default:
                return false;
        }
    }, ldcs);
    const shapes = getSheetShapes((_arg) => false, ldcs);
    const parentsOf = ofList(map_3((tupledArg_1) => [tupledArg_1[0], List_distinct(map_3((tuple_1) => tuple_1[1], tupledArg_1[1]), {
        Equals: (x_2, y_2) => (x_2 === y_2),
        GetHashCode: (x_2) => (stringHash(x_2) | 0),
    })], List_groupBy((tuple) => tuple[0], collect((tupledArg) => map_3((inst_1) => [inst_1.InstSheet, tupledArg[0]], tupledArg[1]), toList_1(shapes)), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => (stringHash(x_1) | 0),
    })), {
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    });
    const spread = (avoid_mut, seen_mut, frontier_mut) => {
        spread:
        while (true) {
            const avoid = avoid_mut, seen = seen_mut, frontier = frontier_mut;
            let option_1;
            if (!isEmpty(frontier)) {
                const fresh = filter_1((child_1) => {
                    if (child_1 !== avoid) {
                        return !contains_1(child_1, seen);
                    }
                    else {
                        return false;
                    }
                }, defaultArg((option_1 = tryFind(head(frontier), shapes), (option_1 != null) ? List_distinct(map_3((inst) => inst.InstSheet, option_1), {
                    Equals: (x, y) => (x === y),
                    GetHashCode: (x) => (stringHash(x) | 0),
                }) : undefined), empty_1()));
                avoid_mut = avoid;
                seen_mut = fold((s, c) => add(c, s), seen, fresh);
                frontier_mut = append(fresh, tail(frontier));
                continue spread;
            }
            else {
                return seen;
            }
            break;
        }
    };
    const reachableFrom = (avoid_1, starts) => {
        const starts_1 = filter_1((s_1) => (s_1 !== avoid_1), starts);
        return spread(avoid_1, ofList_1(starts_1, {
            Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
        }), starts_1);
    };
    if (isEmpty(userSheets)) {
        return undefined;
    }
    else {
        return (sheet_2 = maxBy((ldc_1) => ldc_1.TimeStamp, userSheets, {
            Compare: (x_6, y_6) => (compare_1(x_6, y_6) | 0),
        }).Name, (above = filter_1((s_2) => {
            if (s_2 === sheet_2) {
                return true;
            }
            else {
                return contains_1(sheet_2, reachableFrom("", singleton(s_2)));
            }
        }, map_3((tuple_2) => tuple_2[0], toList_1(shapes))), (roots = filter_1((s_3) => equals(tryFind(s_3, parentsOf), undefined), above), isEmpty(roots) ? sheet_2 : ((dominators = filter_1((s_4) => !contains_1(sheet_2, reachableFrom(s_4, roots)), above), maxBy((d) => {
            const below = reachableFrom("", singleton(d));
            return length(filter_1((o) => {
                if (o === d) {
                    return true;
                }
                else {
                    return contains_1(o, below);
                }
            }, dominators)) | 0;
        }, dominators, {
            Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
        }))))));
    }
}

export function allRootSheets(sTrees) {
    let source;
    const subSheetsOf = (path, sh) => {
        let matchValue;
        return List_distinct(collect((ssh) => {
            if (contains(ssh.SheetName, path, {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            })) {
                return empty_1();
            }
            else {
                return cons(ssh.SheetName, subSheetsOf(cons(ssh.SheetName, path), ssh.SheetName));
            }
        }, (matchValue = tryFind(sh, sTrees), (matchValue == null) ? empty_1() : matchValue.SubSheets)), {
            Equals: (x_1, y_1) => (x_1 === y_1),
            GetHashCode: (x_1) => (stringHash(x_1) | 0),
        });
    };
    const set$_1 = ofSeq((source = MapModule_KeysA(sTrees), collect_1(curry2(subSheetsOf)(empty_1()), source)), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    });
    return difference(ofSeq(MapModule_KeysA(sTrees), {
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    }), set$_1);
}

/**
 * Works out number of components and connections changed between two LoadedComponent circuits
 * a new ID => a change even if the circuit topology is identical. Layout differences do not
 * mean changes, as is implemented in the reduce functions which remove layout.
 */
export function quantifyChanges(ldc1, ldc2) {
    const patternInput = ldc1.CanvasState;
    const patternInput_1 = ldc2.CanvasState;
    const unmatched = (reduce, lst1, lst2) => {
        const mapToSet = (arg) => ofSeq(map_3(reduce, arg), {
            Compare: (x, y) => (compare_2(x, y) | 0),
        });
        const matchValue = mapToSet(lst1);
        const rL2 = mapToSet(lst2);
        const rL1 = matchValue;
        return count(union(difference(rL1, rL2), difference(rL2, rL1))) | 0;
    };
    return [unmatched((comp1) => (new Component(comp1.Id, comp1.Type, comp1.Label, comp1.InputPorts, comp1.OutputPorts, 0, 0, comp1.H, comp1.W, comp1.SymbolInfo, comp1.SlotInfo)), patternInput[0], patternInput_1[0]), unmatched((conn1) => (new Connection(conn1.Id, conn1.Source, conn1.Target, empty_1())), patternInput[1], patternInput_1[1])];
}

/**
 * Write a sheet to the file it came from, whichever of the two forms that file is: an ordinary
 * .dgm, or a component of a library opened as a project. See ComponentLibraries.writeSheetFile.
 */
export function writeComponentToFile(comp) {
    return writeSheetFile(comp.FilePath, comp.CanvasState, comp.WaveInfo, new SheetInfo_1(comp.Form, comp.Description, comp.LCParameterSlots, comp.IsTopSheet, comp.ArrayInfo));
}

/**
 * Drop library sheets that nothing instantiates any more, deleting their files.
 * Run when the project is saved rather than when an instance is deleted: undo restores model
 * snapshots, so deleting the sheet at deletion time would leave undo unable to bring it back.
 */
export function sweepUnusedLibrarySheets(model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const matchValue_1 = unusedLibrarySheets(project.LoadedComponents);
        if (isEmpty(matchValue_1)) {
            return model;
        }
        else {
            const toRemove = filter_2((name) => !contains_1(name, model.OpenedLibrarySheets), remove(project.OpenFileName, ofList_1(map_3((ldc) => ldc.Name, matchValue_1), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            })));
            iterate((name_1) => {
                const matchValue_2 = tryFind_1((ldc_1) => (ldc_1.Name === name_1), project.LoadedComponents);
                if (matchValue_2 == null) {
                }
                else {
                    const ldc_2 = matchValue_2;
                    removeFileWithExtn(sheetExtension(project), project.ProjectPath, ldc_2.Name);
                }
            }, toRemove);
            return new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, filter_1((ldc_3) => !contains_1(ldc_3.Name, toRemove), project.LoadedComponents)), model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState);
        }
    }
    else {
        return model;
    }
}

/**
 * Write every sheet that differs from its file, except the open one, and clear its flag.
 * 
 * ONLY THE OPEN SHEET MAY BE UNSAVED. A change to one sheet routinely reaches others - binding a
 * parameter writes it on every instance, reconciling ports rewrites the sheets that hold them,
 * setting the top sheet rewrites the flag on all of them - and a closed sheet left waiting for a
 * save is a sheet the user cannot see, did not knowingly edit, and has no reason to save. Several
 * places used to mark such sheets and leave them, so the state existed and had to be handled at
 * project close.
 * 
 * A library component's sheet belongs to its library and is never written back, whatever asks; it
 * is left alone here and not called unsaved either.
 */
export function saveDirtyClosedSheets(openSheet, ldcs) {
    return map_3((ldc) => {
        const matchValue = (ldc.LoadedComponentIsOutOfDate && (ldc.Name !== openSheet)) && !isLibrarySheet(ldc);
        if (matchValue) {
            writeComponentToFile(ldc);
            return new LoadedComponent(ldc.Name, now(), ldc.FilePath, ldc.WaveInfo, ldc.CanvasState, ldc.InputLabels, ldc.OutputLabels, ldc.LCParameterSlots, ldc.Form, false, ldc.Description, ldc.IsTopSheet, ldc.ArrayInfo);
        }
        else {
            return ldc;
        }
    }, ldcs);
}

/**
 * Make the named sheet the current top sheet governing parameter display, clearing the flag
 * from every other sheet. The flag is per-sheet view state persisted in the .dgm file.
 * Every sheet but the open one is written at once, so the choice survives without a manual save.
 */
export function setTopSheetState(sheetName, model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const ldcs_1 = saveDirtyClosedSheets(project.OpenFileName, map_3((ldc) => {
            const flag = ldc.Name === sheetName;
            if (flag === ldc.IsTopSheet) {
                return ldc;
            }
            else {
                return new LoadedComponent(ldc.Name, ldc.TimeStamp, ldc.FilePath, ldc.WaveInfo, ldc.CanvasState, ldc.InputLabels, ldc.OutputLabels, ldc.LCParameterSlots, ldc.Form, true, ldc.Description, flag, ldc.ArrayInfo);
            }
        }, project.LoadedComponents));
        const m = new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, ldcs_1), model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState);
        if (exists((ldc_1) => ldc_1.LoadedComponentIsOutOfDate, ldcs_1)) {
            return Optic_Set_op_HatEquals_Z147477F8_1(Optic_Set.Set$, savedSheetIsOutOfDate_)(true)(m);
        }
        else {
            return m;
        }
    }
    else {
        return model;
    }
}

/**
 * return an option containing sequence data and file name and directory of the latest
 * backup file for given component, if it exists.
 */
export function readLastBackup(comp) {
    let tupledArg;
    const path = pathWithoutExtension(comp.FilePath);
    const baseN = baseName_1(path);
    const backupDir = backupDirOf(dirName(path));
    const option_1 = latestBackupFileData(backupDir, baseN);
    if (option_1 != null) {
        return (tupledArg = option_1, [tupledArg[0], tupledArg[1], backupDir]);
    }
    else {
        return undefined;
    }
}

/**
 * Write Loadedcomponent comp to a backup file if there has been any change.
 * Overwrite the existing backup file only if it is a small, and recent, change.
 * Parameters determine thresholds of smallness and recency
 * return () - display an error if the write goes wrong.
 */
export function writeComponentToBackupFile(numCircuitChanges, numHours, comp, dispatch) {
    let tupledArg, tupledArg_1, arg_1, arg_2;
    let patternInput;
    const matchValue = readLastBackup(comp);
    patternInput = ((matchValue == null) ? [0, "", backupDirOf(comp.FilePath)] : [matchValue[0] + 1, matchValue[1], matchValue[2]]);
    const backupFileName = patternInput[1];
    let patternInput_2;
    if (backupFileName === "") {
        patternInput_2 = [true, undefined];
    }
    else {
        const oldBackupFile = pathJoin([patternInput[2], backupFileName]);
        const matchValue_1 = tryLoadComponentFromPath(oldBackupFile);
        if (matchValue_1.tag === 0) {
            const comp$0027 = matchValue_1.fields[0];
            if (!compareIOs(comp, comp$0027)) {
                patternInput_2 = [true, undefined];
            }
            else if ((tupledArg = comp.CanvasState, (tupledArg_1 = comp$0027.CanvasState, compareCanvas(10000, tupledArg[0], tupledArg[1], tupledArg_1[0], tupledArg_1[1])))) {
                patternInput_2 = [false, undefined];
            }
            else {
                const patternInput_1 = quantifyChanges(comp$0027, comp);
                patternInput_2 = (((totalHours(op_Subtraction(comp.TimeStamp, comp$0027.TimeStamp)) > numHours) ? true : ((patternInput_1[0] + patternInput_1[1]) > numCircuitChanges)) ? [true, undefined] : [true, oldBackupFile]);
            }
        }
        else {
            error(`writing a component backup: ${matchValue_1}`);
            patternInput_2 = [true, undefined];
        }
    }
    const oldFile = patternInput_2[1];
    if (patternInput_2[0]) {
        const timestamp = now();
        let backupPath;
        const path_1 = pathWithoutExtension(comp.FilePath);
        const baseN = baseName_1(path_1);
        const ds = StringModule_ReplaceChar("/", "-", toShortDateString(timestamp));
        const suffix = StringModule_ReplaceChar(" ", "-", (arg_1 = (hour(timestamp) | 0), (arg_2 = (minute(timestamp) | 0), toText(printf("%s-%02dh-%02dm"))(ds)(arg_1)(arg_2))));
        const backupDir = backupDirOf(dirName(path_1));
        ensureDirectory(backupDir);
        backupPath = pathJoin([backupDir, toText(printf("%s-%03d-%s.dgm"))(baseN)(patternInput[0])(suffix)]);
        displayAlertOnError(dispatch, writeComponentToFile(new LoadedComponent(comp.Name, timestamp, backupPath, comp.WaveInfo, comp.CanvasState, comp.InputLabels, comp.OutputLabels, comp.LCParameterSlots, comp.Form, comp.LoadedComponentIsOutOfDate, comp.Description, comp.IsTopSheet, comp.ArrayInfo)));
        let matchResult, oldPath_1;
        if (oldFile != null) {
            if (oldFile !== backupPath) {
                matchResult = 0;
                oldPath_1 = oldFile;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                if (exists_1(oldPath_1)) {
                    unlink(oldPath_1);
                }
                break;
            }
            case 1: {
                break;
            }
        }
    }
}

/**
 * Write Loadedcomponent comp to a backup file if there has been any change.
 * Overwrite the existing backup file only if it is a small, and recent, change.
 * Parameters determine thresholds of smallness and recency
 * return () - ignore errors
 */
export function writeComponentToBackupFileNow(numCircuitChanges, numHours, comp) {
    let tupledArg, tupledArg_1, arg_1, arg_2;
    let patternInput;
    const matchValue = readLastBackup(comp);
    patternInput = ((matchValue == null) ? [0, "", backupDirOf(comp.FilePath)] : [matchValue[0] + 1, matchValue[1], matchValue[2]]);
    const backupFileName = patternInput[1];
    let patternInput_2;
    if (backupFileName === "") {
        patternInput_2 = [true, undefined];
    }
    else {
        const oldBackupFile = pathJoin([patternInput[2], backupFileName]);
        const matchValue_1 = tryLoadComponentFromPath(oldBackupFile);
        if (matchValue_1.tag === 0) {
            const comp$0027 = matchValue_1.fields[0];
            if (!compareIOs(comp, comp$0027)) {
                patternInput_2 = [true, undefined];
            }
            else if ((tupledArg = comp.CanvasState, (tupledArg_1 = comp$0027.CanvasState, compareCanvas(10000, tupledArg[0], tupledArg[1], tupledArg_1[0], tupledArg_1[1])))) {
                patternInput_2 = [false, undefined];
            }
            else {
                const patternInput_1 = quantifyChanges(comp$0027, comp);
                patternInput_2 = (((totalHours(op_Subtraction(comp.TimeStamp, comp$0027.TimeStamp)) > numHours) ? true : ((patternInput_1[0] + patternInput_1[1]) > numCircuitChanges)) ? [true, undefined] : [true, oldBackupFile]);
            }
        }
        else {
            error(`writing a component backup: ${matchValue_1}`);
            patternInput_2 = [true, undefined];
        }
    }
    const oldFile = patternInput_2[1];
    if (patternInput_2[0]) {
        const timestamp = now();
        let backupPath;
        const path_1 = pathWithoutExtension(comp.FilePath);
        const baseN = baseName_1(path_1);
        const ds = StringModule_ReplaceChar("/", "-", toShortDateString(timestamp));
        const suffix = StringModule_ReplaceChar(" ", "-", (arg_1 = (hour(timestamp) | 0), (arg_2 = (minute(timestamp) | 0), toText(printf("%s-%02dh-%02dm"))(ds)(arg_1)(arg_2))));
        const backupDir = backupDirOf(dirName(path_1));
        ensureDirectory(backupDir);
        backupPath = pathJoin([backupDir, toText(printf("%s-%03d-%s.dgm"))(baseN)(patternInput[0])(suffix)]);
        writeComponentToFile(new LoadedComponent(comp.Name, timestamp, backupPath, comp.WaveInfo, comp.CanvasState, comp.InputLabels, comp.OutputLabels, comp.LCParameterSlots, comp.Form, comp.LoadedComponentIsOutOfDate, comp.Description, comp.IsTopSheet, comp.ArrayInfo));
        let matchResult, oldPath_1;
        if (oldFile != null) {
            if (oldFile !== backupPath) {
                matchResult = 0;
                oldPath_1 = oldFile;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                if (exists_1(oldPath_1)) {
                    unlink(oldPath_1);
                }
                break;
            }
            case 1: {
                break;
            }
        }
    }
}

export function getFileInProject(name, project) {
    return tryFind_1((comp) => (comp.Name === name), project.LoadedComponents);
}

export function isFileInProject(name, project) {
    const _arg = getFileInProject(name, project);
    if (_arg != null) {
        return true;
    }
    else {
        return false;
    }
}

function loadStateIntoModel(finishUI, compToSetup, waveSim, ldComps, model, dispatch) {
    const ldcs = tryGetLoadedComponents(model);
    const name = compToSetup.Name;
    const patternInput = compToSetup.CanvasState;
    const connections = patternInput[1];
    const msgs = toList_2(delay(() => append_1(singleton_1(new Msg(/* UpdateModel */ 41, [Optic_Set_op_HatEquals_Z147477F8_1(Optic_Set.Set$, readOnlyBaseline_)(undefined)])), delay(() => append_1(singleton_1(new Msg(/* SetHighlighted */ 35, [empty_1(), empty_1()])), delay(() => append_1(singleton_1(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.ResetModel])), delay(() => append_1(singleton_1(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [DrawModelType_BusWireT_Msg.ResetModel])])), delay(() => append_1(singleton_1(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [DrawModelType_SymbolT_Msg.ResetModel])])])), delay(() => append_1(singleton_1(new Msg(/* SetIsLoading */ 103, [true])), delay(() => append_1(singleton_1(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* LoadComponents */ 29, [ldcs, patternInput[0]])])])])), delay(() => append_1(singleton_1(new Msg(/* UpdateModel */ 41, [(m) => {
        const _arg = tryFind_1((lc) => (lc.Name === name), ldcs);
        return (_arg == null) ? m : syncArrayTextFor(_arg, m);
    }])), delay(() => append_1(singleton_1(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* LoadConnections */ 19, [connections])])])), delay(() => append_1(singleton_1(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.FlushCommandStack])), delay(() => append_1(singleton_1(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [DrawModelType_BusWireT_Msg.BusWidths])])), delay(() => append_1(singleton_1(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.UpdateBoundingBoxes])), delay(() => append_1(singleton_1(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* MakeJumps */ 14, [true, map_3((conn) => conn.Id, connections)])])])), delay(() => append_1(singleton_1(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [DrawModelType_BusWireT_Msg.RerouteAllFloatingWires])])), delay(() => append_1(singleton_1(new Msg(/* AddWSModel */ 11, [[name, waveSim]])), delay(() => append_1(singleton_1(new Msg(/* SetProject */ 39, [new Project(dirName(compToSetup.FilePath), compToSetup.Name, compToSetup.Name, ldComps)])), delay(() => append_1(singleton_1(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* KeyPress */ 2, [DrawModelType_SheetT_KeyboardMsg.CtrlW])])), delay(() => append_1(singleton_1(Msg.SynchroniseCanvas), delay(() => append_1(singleton_1(new Msg(/* SetIsLoading */ 103, [false])), delay(() => append_1(finishUI ? singleton_1(Msg.FinishUICmd) : singleton_1(Msg.DoNothing), delay(() => append_1(singleton_1(Msg.CheckTopSheetChoice), delay(() => append_1(singleton_1(Msg.PropagateParameters), delay(() => append_1(singleton_1(new Msg(/* ExecFuncInMessage */ 116, [(_arg_1, dispatch_1) => {
        window.requestAnimationFrame((_arg_2) => {
            window.requestAnimationFrame((_arg_3) => {
                dispatch_1(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* KeyPress */ 2, [DrawModelType_SheetT_KeyboardMsg.CtrlW])]));
                dispatch_1(Msg.SynchroniseCanvas);
            });
        });
    }, dispatch])), delay(() => singleton_1(Msg.PinReadOnlyCanvas)))))))))))))))))))))))))))))))))))))))))))))))));
    dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* SetSpinner */ 33, [true])]));
    dispatch(new Msg(/* SendSeqMsgAsynch */ 119, [msgs]));
}

/**
 * Load a new project as defined by parameters.
 * Ends any existing simulation
 * Closes WaveSim if this is being used
 */
export function setupProjectFromComponents(finishUI, sheetName, ldComps, model, dispatch) {
    let option_1, option_4;
    const ldComps_1 = bindMissingInstanceParams(ldComps);
    let compToSetup;
    if (isEmpty(ldComps_1)) {
        compToSetup = toFail(printf("setupProjectComponents must be called with at least one LoadedComponent"));
    }
    else {
        const comps = ldComps_1;
        const matchValue = tryFind_1((comp) => (comp.Name === sheetName), comps);
        if (matchValue != null) {
            compToSetup = matchValue;
        }
        else {
            const arg_1 = map_3((c) => c.Name, comps);
            compToSetup = toFail(printf("What? can\'t find sheet %s in loaded sheets %A"))(sheetName)(arg_1);
        }
    }
    let leavingProject;
    const matchValue_1 = model.CurrentProj;
    leavingProject = ((matchValue_1 == null) ? true : (matchValue_1.ProjectPath !== dirName(compToSetup.FilePath)));
    const matchValue_2 = model.CurrentProj;
    if (matchValue_2 != null) {
        dispatch(Msg.EndSimulation);
        dispatch(new Msg(/* TruthTableMsg */ 32, [TTMsg.CloseTruthTable]));
        if ((leavingProject && !equals(model.WaveSimSheet, undefined)) && !equals(model.WaveSimSheet, "")) {
            dispatch(Msg.EndWaveSim);
        }
    }
    const savedWaveSim = defaultArg((option_1 = compToSetup.WaveInfo, (option_1 != null) ? loadWSModelFromSavedWaveInfo(ldComps_1, compToSetup.Name, option_1) : undefined), initWSModel);
    loadStateIntoModel(finishUI, compToSetup, leavingProject ? savedWaveSim : defaultArg((option_4 = model.WaveSimSheet, (option_4 != null) ? tryFind(option_4, model.WaveSim) : undefined), savedWaveSim), ldComps_1, model, dispatch);
}

function createEmptyDiagramFile(projectPath, name) {
    createEmptyDgmFile(projectPath, name);
    return new LoadedComponent(name, now(), pathJoin([projectPath, name + ".dgm"]), undefined, [empty_1(), empty_1()], empty_1(), empty_1(), undefined, CCForm.User, false, undefined, false, undefined);
}

function writeComponentKeepingTimeStamp(comp) {
    return writeSheetFileAt(comp.TimeStamp, comp.FilePath, comp.CanvasState, comp.WaveInfo, new SheetInfo_1(comp.Form, comp.Description, comp.LCParameterSlots, comp.IsTopSheet, comp.ArrayInfo));
}

/**
 * Put a project's files into the current id form when they were read in the old one.
 * 
 * Ids became integers; a .dgm written before that holds uuids, and every load allocates integers
 * for them afresh. The mapping is deterministic, so the design works either way - but nothing on
 * disk ever changes, so the ids in the file match nothing anyone can see in the running app, and
 * every open pays the conversion again. Opening the project is where it is settled, once.
 * 
 * The WHOLE project or none of it. Component ids are design-unique, and admitting the sheets
 * re-mints any that collide - so a sheet whose own ids were already integers can still have come
 * out of the load different from its file, and writing only the uuid ones would leave the design
 * half-converted.
 * 
 * Not for a project Issie may only write nothing to - the shipped demos read from the read-only
 * static directory, a folder on a read-only share. There is no asking in advance whether a
 * directory can be written, so the first refusal is the answer: the write is attempted, and a
 * project that refuses it simply keeps its old ids. Said in the log and nowhere else, because
 * nothing about the design is wrong and there is nothing for the user to do.
 * 
 * A library sheet belongs to its library and is never written back, whatever asks. A library
 * opened AS a project is written like anything else - its components are the sheets - and needs no
 * exception here: one whose ids are already integers needs no conversion, so nothing is written
 * for it.
 * 
 * Returns the sheets, and the names of those actually written - empty when nothing needed
 * converting, and empty when the project could not be written. That is what the caller tells the
 * user about: this is a legacy conversion, it changes every file of the project, and it should not
 * happen silently.
 */
export function convertProjectIdsOnDisk(ldcs) {
    if (!exists((ldc) => ldc.LoadedComponentIsOutOfDate, ldcs)) {
        return [ldcs, empty_1()];
    }
    else {
        const patternInput = fold((tupledArg, ldc_2) => {
            const written = tupledArg[0];
            const refused = tupledArg[1];
            if (refused == null) {
                const matchValue = writeComponentKeepingTimeStamp(ldc_2);
                if (matchValue.tag === 1) {
                    return [written, matchValue.fields[0]];
                }
                else {
                    return [cons(ldc_2.Name, written), undefined];
                }
            }
            else {
                return [written, refused];
            }
        }, [empty_1(), undefined], filter_1((ldc_1) => !isLibrarySheet(ldc_1), ldcs));
        const writable = patternInput[0];
        const refused_1 = patternInput[1];
        if (refused_1 == null) {
            dbg(128, "project ids written in their new form on: " + StringModule_Concat(", ", reverse(writable)));
        }
        else {
            dbg(128, concat("project ids left in their old form - it cannot be written: ", refused_1));
        }
        return [map_3((ldc_3) => (new LoadedComponent(ldc_3.Name, ldc_3.TimeStamp, ldc_3.FilePath, ldc_3.WaveInfo, ldc_3.CanvasState, ldc_3.InputLabels, ldc_3.OutputLabels, ldc_3.LCParameterSlots, ldc_3.Form, false, ldc_3.Description, ldc_3.IsTopSheet, ldc_3.ArrayInfo)), ldcs), (refused_1 == null) ? reverse(writable) : empty_1()];
    }
}

export function resolveComponentOpenPopup(pPath_mut, components_mut, resolves_mut, model_mut, dispatch_mut) {
    resolveComponentOpenPopup:
    while (true) {
        const pPath = pPath_mut, components = components_mut, resolves = resolves_mut, model = model_mut, dispatch = dispatch_mut;
        let props_2, comps, option_1;
        dispatch(Msg.ClosePopup);
        if (!isEmpty(resolves)) {
            switch (head(resolves).tag) {
                case 2: {
                    displayFileErrorNotification("Could not load saved project file \'%s\' - using autosave file instead", dispatch);
                    pPath_mut = pPath;
                    components_mut = cons(head(resolves).fields[0], components);
                    resolves_mut = tail(resolves);
                    model_mut = model;
                    dispatch_mut = dispatch;
                    continue resolveComponentOpenPopup;
                    break;
                }
                case 1: {
                    pPath_mut = pPath;
                    components_mut = cons(head(resolves).fields[0], components);
                    resolves_mut = tail(resolves);
                    model_mut = model;
                    dispatch_mut = dispatch;
                    continue resolveComponentOpenPopup;
                    break;
                }
                default: {
                    const patternInput_2 = quantifyChanges(head(resolves).fields[0], head(resolves).fields[1]);
                    const connChanges = patternInput_2[1] | 0;
                    const compChanges = patternInput_2[0] | 0;
                    let patternInput_3;
                    const matchValue = (compChanges + connChanges) | 0;
                    patternInput_3 = ((matchValue === 0) ? [toText(printf("There were layout but no circuit changes made in sheet %s after your last save. There is an automatically saved version which is more uptodate. Do you want to keep the newer AutoSaved version or the older Saved version?"))(head(resolves).fields[0].Name), "green"] : ((matchValue < 3) ? [toText(printf("Warning: %d component and %d connection changes were made to sheet \'%s\' after your last Save. There is an automatically saved version which is more uptodate. Do you want to keep the newer AutoSaved version or the older saved version?"))(compChanges)(connChanges)(head(resolves).fields[0].Name), "orange"] : [toText(printf("Warning: %d component and %d connection changes were made to sheet \'%s\' after your last Save. There is an automatically saved version which is more uptodate. Do you want to keep the newer AutoSaved version or the older saved version? This is a large change so the option you do not choose will be saved as file \'backup/%s.dgm\'"))(compChanges)(connChanges)(head(resolves).fields[0].Name)(head(resolves).fields[0].Name), "red"]));
                    choicePopup("Warning!", (props_2 = [["style", {
                        color: patternInput_3[1],
                    }]], react_1.createElement("div", keyValueList(props_2, 1), patternInput_3[0])), "Newer AutoSaved file", "Older Saved file", (autoSave, _arg) => {
                        let comp;
                        const bind$0040 = autoSave ? head(resolves).fields[1] : head(resolves).fields[0];
                        comp = (new LoadedComponent(bind$0040.Name, now(), bind$0040.FilePath, bind$0040.WaveInfo, bind$0040.CanvasState, bind$0040.InputLabels, bind$0040.OutputLabels, bind$0040.LCParameterSlots, bind$0040.Form, bind$0040.LoadedComponentIsOutOfDate, bind$0040.Description, bind$0040.IsTopSheet, bind$0040.ArrayInfo));
                        displayAlertOnError(dispatch, writeComponentToFile(comp));
                        if ((compChanges + connChanges) > 0) {
                            writeComponentToBackupFile(0, 1, comp, dispatch);
                        }
                        resolveComponentOpenPopup(pPath, cons(comp, components), tail(resolves), model, dispatch);
                    }, dispatch);
                }
            }
        }
        else {
            const patternInput = RegenerateIds_admitDesign(reverse(components));
            const corrected = patternInput[1];
            if (isEmpty(corrected)) {
            }
            else {
                dbg(128, "project open renumbered ids on: " + StringModule_Concat(", ", corrected));
            }
            const patternInput_1 = convertProjectIdsOnDisk(patternInput[0]);
            const ldcs_1 = patternInput_1[0];
            const convertedOnDisk = patternInput_1[1];
            setupProjectFromComponents(false, (comps = ldcs_1, defaultArg(orElse(sheetOpenedOnLoad(comps), (option_1 = tryHead(comps), (option_1 != null) ? option_1.Name : undefined)), "")), ldcs_1, model, dispatch);
            if (isEmpty(convertedOnDisk)) {
            }
            else {
                closablePopup("Project files updated", helpText(Confirm_idsConverted(convertedOnDisk)), react_1.createElement("div", {}), empty_1(), dispatch);
            }
        }
        break;
    }
}

function trimRecents(recents) {
    return truncate(Constants_numberOfRecentProjects, List_distinct(map_3(normalisePath, recents), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }));
}

/**
 * A recent list as it came out of the settings file, in the form the rest of the code holds it in.
 * Settings written before paths were normalised have the same project under two spellings, and one
 * written by an older version can be longer than the limit; tidying on the way IN means the next
 * write of the settings file heals it, rather than leaving that to the next project opened.
 */
export function tidyRecents(recents) {
    const option_1 = recents;
    if (option_1 != null) {
        return trimRecents(option_1);
    }
    else {
        return undefined;
    }
}

function withoutRecent(path, recents) {
    let mapping;
    let f2;
    let predicate;
    const x = normalisePath(path);
    predicate = ((y) => (x !== y));
    f2 = ((list) => filter_1(predicate, list));
    mapping = ((arg) => f2(trimRecents(arg)));
    const option_1 = recents;
    if (option_1 != null) {
        return mapping(option_1);
    }
    else {
        return undefined;
    }
}

export function addToRecents(path, recents) {
    const path_1 = normalisePath(path);
    return trimRecents(insertAt(0, path_1, filter_1((y) => (path_1 !== y), trimRecents(defaultArg(recents, empty_1())))));
}

/**
 * The recent projects to offer, newest first. Read the list through this rather than from
 * UserData directly.
 */
export function recentProjects(model) {
    return trimRecents(defaultArg(model.UserData.RecentProjects, empty_1()));
}

/**
 * Take one project off the recent list. The project itself is untouched.
 */
export function forgetRecentProject(path, model, dispatch) {
    let bind$0040;
    return dispatch(new Msg(/* SetUserData */ 113, [(bind$0040 = model.UserData, new UserData(bind$0040.UserAppDir, bind$0040.LastUsedDirectory, withoutRecent(path, model.UserData.RecentProjects), bind$0040.ArrowDisplay, bind$0040.WireType, bind$0040.Theme))]));
}

/**
 * One row of a recent-projects list: the project, which opens on a click, and a cross that takes
 * it off the list.
 * 
 * Only opening a project ever put one here, and only opening four others ever took it away - so a
 * project opened once by mistake, or one whose folder has since been moved or deleted, sat at the
 * top of the list of five for as long as it took to open five more. The cross is worded and
 * coloured as removal from a list rather than deletion, because that is all it is: nothing on
 * disk changes.
 */
export function recentProjectItem(path, label, openIt, model, dispatch) {
    let children_4, props, props_2;
    return Item_li(ofArray([new Item_Option(/* IsActive */ 0, [false]), new Item_Option(/* OnClick */ 3, [(_arg) => {
        openIt(path);
    }])]), singleton((children_4 = [(props = [new HTMLAttr(/* Title */ 158, [path]), ["style", {
        flex: "1",
        minWidth: "0",
        overflowX: "hidden",
        overflowY: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    }]], react_1.createElement("div", keyValueList(props, 1), label)), (props_2 = [new HTMLAttr(/* Class */ 65, ["recentForget"]), new HTMLAttr(/* Title */ 158, [concat("Remove \'", baseName_1(path), "\' from this list. The project itself is not deleted.")]), new DOMAttr(/* OnClick */ 40, [(ev) => {
        ev.stopPropagation();
        forgetRecentProject(path, model, dispatch);
    }])], react_1.createElement("span", keyValueList(props_2, 1), "✕"))], react_1.createElement("div", {
        className: "recentItem",
    }, ...children_4))));
}

/**
 * open an existing demo project from its path
 */
export function openDemoProjectFromPath(path, model, dispatch) {
    warnAppWidth(dispatch, () => {
        dbg(128, concat("loading demo project ", path));
        const matchValue = loadAllComponentFiles(path);
        if (matchValue.tag === 0) {
            resolveComponentOpenPopup(path, empty_1(), matchValue.fields[0], model, dispatch);
            dbg(128, concat("opened project ", path));
        }
        else {
            const err = matchValue.fields[0];
            warn_1(err);
            displayFileErrorNotification(err, dispatch);
        }
    });
}

function loadProjectDirectory(path) {
    const matchValue = inspectProjectDirectory(path);
    if (matchValue.tag === 2) {
        if (!libraryPathIsEditable(path)) {
            return new FSharpResult$2(/* Error */ 1, [concat(baseName_1(path), " is one of Issie\'s own component libraries and is not edited in                 place. Save a component from it into a sheet, or keep your own library in a folder                 of your own.")]);
        }
        else {
            return tryLoadLibraryProject(path);
        }
    }
    else {
        return loadAllComponentFiles(path);
    }
}

/**
 * open an existing project from its path
 */
export function openProjectFromPath(path, model, dispatch) {
    warnAppWidth(dispatch, () => {
        dispatch(new Msg(/* ExecFuncAsynch */ 117, [() => {
            let bind$0040, matchValue, err;
            dbg(128, concat("loading project ", path));
            dispatch(new Msg(/* SetUserData */ 113, [(bind$0040 = model.UserData, new UserData(bind$0040.UserAppDir, path, (matchValue = loadProjectDirectory(path), (matchValue.tag === 0) ? ((resolveComponentOpenPopup(path, empty_1(), matchValue.fields[0], model, dispatch), (dbg(128, concat("opened project ", path)), addToRecents(path, model.UserData.RecentProjects)))) : ((err = matchValue.fields[0], (warn_1(err), (displayFileErrorNotification(err, dispatch), withoutRecent(path, model.UserData.RecentProjects)))))), bind$0040.ArrowDisplay, bind$0040.WireType, bind$0040.Theme))]));
            return Cmd_none();
        }]));
    });
}

/**
 * Open a component library as a project, so that its components can be edited where they are.
 * The catalogue's door to what the project browser reaches by navigating to the folder: one open
 * path, so the refusal above and the recent-projects entry are the same either way in.
 */
export function openLibraryAsProject(library, model, dispatch) {
    openProjectFromPath(library.Path, model, dispatch);
}

/**
 * returns a WaveSimModel option if a file is loaded, otherwise None
 */
export function currWaveSimModel(model) {
    const matchValue = getCurrFile(model);
    if (matchValue != null) {
        return tryFind(matchValue, model.WaveSim);
    }
    else {
        return undefined;
    }
}

/**
 * Return LoadedComponents with sheet name updated according to setFun.
 * Do not update model.
 */
export function updateLoadedComponents(name, setFun, lcLst, dispatch) {
    const n = tryFindIndex((lc) => (lc.Name === name), lcLst);
    if (n != null) {
        const n_1 = n | 0;
        const oldLc = item_1(n_1, lcLst);
        const newLc = setFun(oldLc);
        writeComponentToBackupFile(0, 1, oldLc, dispatch);
        return mapIndexed((i, x) => ((i === n_1) ? newLc : x), lcLst);
    }
    else {
        warn_1(concat("updateLoadedComponents cannot find a sheet named \'", name, "\'"));
        return lcLst;
    }
}

/**
 * return current project with current sheet updated from canvas if needed.
 * Do not update model.
 */
export function updateProjectFromCanvas(model, dispatch) {
    let p;
    const matchValue = DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet);
    let matchResult, canvasState;
    if (openSheetIsReadOnly(model)) {
        matchResult = 0;
    }
    else if (isEmpty(matchValue[0])) {
        if (isEmpty(matchValue[1])) {
            matchResult = 1;
        }
        else {
            matchResult = 2;
            canvasState = matchValue;
        }
    }
    else {
        matchResult = 2;
        canvasState = matchValue;
    }
    switch (matchResult) {
        case 0:
            return model.CurrentProj;
        case 1:
            return model.CurrentProj;
        default: {
            const canvas = canvasState;
            const option_1 = model.CurrentProj;
            if (option_1 != null) {
                return (p = option_1, new Project(p.ProjectPath, p.OpenFileName, p.WorkingFileName, updateLoadedComponents(p.OpenFileName, (lc) => {
                    const slots = tidyParamSlots(canvas[0], canvas[1], lc.LCParameterSlots);
                    const patternInput = parseDiagramSignatureFor(lc.ArrayInfo, slots, canvas[0], canvas[1]);
                    return new LoadedComponent(lc.Name, lc.TimeStamp, lc.FilePath, lc.WaveInfo, canvas, patternInput[0], patternInput[1], slots, lc.Form, lc.LoadedComponentIsOutOfDate, lc.Description, lc.IsTopSheet, lc.ArrayInfo);
                }, p.LoadedComponents, dispatch)));
            }
            else {
                return undefined;
            }
        }
    }
}

/**
 * extract SavedWaveInfo from model to be saved.
 * 
 * Takes the design to walk rather than reading it off the project, because the selection is saved
 * as label paths and the project's copy of the sheet being saved is the version before the save -
 * see designWithSheet, which is what every caller passes.
 */
export function getSavedWave(ldcs, model) {
    const matchValue = currWaveSimModel(model);
    const matchValue_1 = getCurrFile(model);
    let matchResult, sheet, wsModel;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            matchResult = 0;
            sheet = matchValue_1;
            wsModel = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return getSavedWaveInfo(ldcs, sheet, wsModel);
        default:
            return undefined;
    }
}

/**
 * Save the sheet currently open, return  the new sheet's Loadedcomponent if this has changed.
 * Do not change model.
 * update Symbol model with new RAM contents.
 */
export function saveOpenFileAction(isAuto, model, dispatch) {
    const matchValue = DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet);
    const matchValue_1 = model.CurrentProj;
    if (openSheetIsReadOnly(model)) {
        return undefined;
    }
    else if (matchValue_1 != null) {
        const project = matchValue_1;
        const canvasState = matchValue;
        const ldc = find((lc) => (lc.Name === project.OpenFileName), project.LoadedComponents);
        const sheetInfo = new SheetInfo_1(ldc.Form, ldc.Description, tidyParamSlots(canvasState[0], canvasState[1], ldc.LCParameterSlots), ldc.IsTopSheet, ldc.ArrayInfo);
        const design = designWithSheet(project, project.OpenFileName, canvasState[0], canvasState[1]);
        const savedState = [canvasState, getSavedWave(design, model), sheetInfo];
        if (isAuto) {
            toFail(printf("Auto saving is no longer used"));
            return undefined;
        }
        else {
            displayAlertOnError(dispatch, writeSheetFile(sheetFilePath(project, project.OpenFileName), savedState[0], savedState[1], savedState[2]));
            const pr = persistFileToExternalStorageAsync(pathJoin([project.ProjectPath, project.OpenFileName + ".dgm"]));
            void pr;
            removeFileWithExtn(".dgmauto", project.ProjectPath, project.OpenFileName);
            const origLdComp = Optic_Set_op_HatEquals_Z147477F8_1(Optic_Set.Set$, loadedComponentIsOutOfDate_)(false)(find((lc_1) => (lc_1.Name === project.OpenFileName), project.LoadedComponents));
            let savedWaveSim;
            const option_1 = tryFind(project.OpenFileName, model.WaveSim);
            savedWaveSim = ((option_1 != null) ? getSavedWaveInfo(design, project.OpenFileName, option_1) : undefined);
            let SheetInfo;
            const matchValue_3 = origLdComp.Form;
            SheetInfo = ((matchValue_3 != null) ? (new SheetInfo_1(matchValue_3, origLdComp.Description, origLdComp.LCParameterSlots, origLdComp.IsTopSheet, origLdComp.ArrayInfo)) : undefined);
            const patternInput = makeLoadedComponentFromCanvasData(canvasState[0], canvasState[1], origLdComp.FilePath, now(), savedWaveSim, SheetInfo);
            const newLdc = patternInput[0];
            let newState;
            const tupledArg = canvasState;
            newState = [map_3((comp) => {
                const matchValue_4 = tryFind_1((c) => equals(c.Id, comp.Id), patternInput[1]);
                if (matchValue_4 != null) {
                    const newRam = matchValue_4;
                    dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* WriteMemoryType */ 31, [comp.Id, newRam.Type])])])]));
                    return newRam;
                }
                else {
                    return comp;
                }
            }, tupledArg[0]), tupledArg[1]];
            writeComponentToBackupFile(4, 1, newLdc, dispatch);
            return [newLdc, newState];
        }
    }
    else {
        return undefined;
    }
}

/**
 * Save the sheet currently open, return updated model
 * dispatch not needed.
 * currently errors in saving are not processed: because
 * without dispatch we cannot add an alert.
 * this could be changed by using the Notification field in the returned model
 */
export function saveOpenFileToModel(model) {
    const matchValue = DrawModelType_SheetT_Model__Model_GetCanvasState(model.Sheet);
    const matchValue_1 = model.CurrentProj;
    if (openSheetIsReadOnly(model)) {
        return undefined;
    }
    else if (matchValue_1 != null) {
        const project = matchValue_1;
        const canvasState = matchValue;
        const ldc = find((lc) => (lc.Name === project.OpenFileName), project.LoadedComponents);
        const sheetInfo = new SheetInfo_1(ldc.Form, ldc.Description, tidyParamSlots(canvasState[0], canvasState[1], ldc.LCParameterSlots), ldc.IsTopSheet, ldc.ArrayInfo);
        const design = designWithSheet(project, project.OpenFileName, canvasState[0], canvasState[1]);
        const savedState = [canvasState, getSavedWave(design, model), sheetInfo];
        writeSheetFile(sheetFilePath(project, project.OpenFileName), savedState[0], savedState[1], savedState[2]);
        const pr = persistFileToExternalStorageAsync(pathJoin([project.ProjectPath, project.OpenFileName + ".dgm"]));
        void pr;
        removeFileWithExtn(".dgmauto", project.ProjectPath, project.OpenFileName);
        const origLdComp = find((lc_1) => (lc_1.Name === project.OpenFileName), project.LoadedComponents);
        let savedWaveSim;
        const option_1 = tryFind(project.OpenFileName, model.WaveSim);
        savedWaveSim = ((option_1 != null) ? getSavedWaveInfo(design, project.OpenFileName, option_1) : undefined);
        let SheetInfo;
        const matchValue_3 = origLdComp.Form;
        SheetInfo = ((matchValue_3 != null) ? (new SheetInfo_1(matchValue_3, origLdComp.Description, origLdComp.LCParameterSlots, origLdComp.IsTopSheet, origLdComp.ArrayInfo)) : undefined);
        const patternInput = makeLoadedComponentFromCanvasData(canvasState[0], canvasState[1], origLdComp.FilePath, now(), savedWaveSim, SheetInfo);
        const newLdc = patternInput[0];
        let patternInput_2;
        const tupledArg = canvasState;
        const patternInput_1 = fold((tupledArg_1, comp) => {
            let model_1, compId, comp_1, newComp, matchValue_5, l;
            const sModel = tupledArg_1[0];
            const newComps = tupledArg_1[1];
            const matchValue_4 = tryFind_1((c) => equals(c.Id, comp.Id), patternInput[1]);
            if (matchValue_4 != null) {
                const newRam = matchValue_4;
                return [(model_1 = sModel, (compId = comp.Id, (comp_1 = FSharpMap__get_Item(model_1.Symbols, compId).Component, (newComp = (new Component(comp_1.Id, (matchValue_5 = comp_1.Type, (matchValue_5.tag === 41) ? newRam.Type : ((matchValue_5.tag === 42) ? newRam.Type : ((matchValue_5.tag === 40) ? newRam.Type : ((matchValue_5.tag === 39) ? newRam.Type : ((warn(concat("improper use of WriteMemoryType on ", comp_1.Label, " ignored")), comp_1.Type)))))), comp_1.Label, comp_1.InputPorts, comp_1.OutputPorts, comp_1.X, comp_1.Y, comp_1.H, comp_1.W, comp_1.SymbolInfo, comp_1.SlotInfo)), Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, (l = DrawModelType_SymbolT_symbolOf_(compId), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SymbolT_component_)(l)))(newComp)(model_1))))), cons(newRam, newComps)];
            }
            else {
                return [sModel, cons(comp, newComps)];
            }
        }, [model.Sheet.Wire.Symbol, empty_1()], tupledArg[0]);
        patternInput_2 = [patternInput_1[0], [patternInput_1[1], tupledArg[1]]];
        writeComponentToBackupFileNow(4, 1, newLdc);
        const newLdc$0027 = new LoadedComponent(newLdc.Name, newLdc.TimeStamp, newLdc.FilePath, newLdc.WaveInfo, patternInput_2[1], newLdc.InputLabels, newLdc.OutputLabels, newLdc.LCParameterSlots, newLdc.Form, newLdc.LoadedComponentIsOutOfDate, newLdc.Description, newLdc.IsTopSheet, newLdc.ArrayInfo);
        const project$0027 = Optic_Set_op_HatEquals_Z147477F8_1(Optic_Set.Set$, loadedComponentOf_(project.OpenFileName))(newLdc$0027)(project);
        return Optic_Set_op_HatEquals_Z147477F8_1(Optic_Set.Set$, currentProj_)(project$0027)(Optic_Set_op_HatEquals_Z147477F8_1(Optic_Set.Set$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89_1(Compose_Lens.Lens, DrawModelType_SheetT_symbol_)(sheet_))(patternInput_2[0])(model));
    }
    else {
        return undefined;
    }
}

export function saveOpenProjectInNewFormat(model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        return map_3((comp) => {
            const savedState = [comp.CanvasState, undefined, new SheetInfo_1(comp.Form, comp.Description, comp.LCParameterSlots, comp.IsTopSheet, comp.ArrayInfo)];
            const matchValue_1 = saveStateToFileExperimental(project.ProjectPath, comp.Name, savedState[0], savedState[1], savedState[2]);
            if (matchValue_1.tag === 1) {
                error(concat("saving ", comp.Name, ": ", matchValue_1.fields[0]));
            }
            else {
                dbg(128, concat("saved ", comp.Name));
            }
        }, project.LoadedComponents);
    }
    else {
        throw new Exception("No opened project");
    }
}

/**
 * save current open file, updating model etc, and returning the loaded component and the saved (unreduced) canvas state
 */
export function saveOpenFileActionWithModelUpdate(model, dispatch) {
    let option_1;
    const opt = saveOpenFileAction(false, model, dispatch);
    let ldcOpt;
    const option = opt;
    ldcOpt = ((option != null) ? option[0] : undefined);
    defaultArg((option_1 = opt, (option_1 != null) ? option_1[1] : undefined), [empty_1(), empty_1()]);
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const p = matchValue;
        dispatch(new Msg(/* SetProject */ 39, [new Project(p.ProjectPath, p.OpenFileName, p.WorkingFileName, updateLdCompsWithCompOpt(ldcOpt, p.LoadedComponents))]));
    }
    else {
        toFail(printf("What? Should never be able to save sheet when project=None"));
    }
    dispatch(new Msg(/* JSDiagramMsg */ 8, [new JSDiagramMsg(/* SetHasUnsavedChanges */ 4, [false])]));
    dispatch(Msg.FinishUICmd);
    return opt;
}

/**
 * Open the specified file, saving the current file if needed.
 * Creates messages sufficient to do all necessary model and diagram change
 * Terminates a simulation if one is running
 * Closes waveadder if it is open
 */
export function openFileInProject$0027(saveCurrent, name, project, model, dispatch) {
    let option;
    const newModel = new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, project, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState);
    const matchValue = getFileInProject(name, project);
    let matchResult;
    if (matchValue != null) {
        if (matchValue.Form != null) {
            switch (matchValue.Form.tag) {
                case 2: {
                    if (debugLevel() === 0) {
                        matchResult = 1;
                    }
                    else {
                        matchResult = 2;
                    }
                    break;
                }
                case 3: {
                    if (debugLevel() === 0) {
                        matchResult = 1;
                    }
                    else {
                        matchResult = 2;
                    }
                    break;
                }
                default:
                    matchResult = 2;
            }
        }
        else {
            matchResult = 2;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0: {
            warn_1(concat("sheet ", name, ".dgm is not in the project"));
            dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(concat("Warning: Issie could not find the file \'", name, ".dgm\' in the project. Did you delete a file manually?"))]));
            dispatch(Msg.FinishUICmd);
            break;
        }
        case 1: {
            dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(concat("Warning: The sheet \'", name, "\' is protected and cannot be opened."))]));
            dispatch(Msg.FinishUICmd);
            break;
        }
        case 2: {
            if (matchValue != null) {
                if ((isLibrarySheet(matchValue) && !model.ShowLibrarySheets) && !contains_1(name, model.OpenedLibrarySheets)) {
                    const lc_1 = matchValue;
                    dispatch(new Msg(/* SetFilesNotification */ 79, [errorFilesNotification(concat("\'", name, "\' is part of a component library, so it cannot be opened."))]));
                    dispatch(Msg.FinishUICmd);
                }
                else {
                    const lc_2 = matchValue;
                    const matchValue_1 = updateProjectFromCanvas(model, dispatch);
                    if (matchValue_1 != null) {
                        const updatedModel = new Model(newModel.WindowWidth, newModel.KeyFocusPane, newModel.RunAfterRenderWithSpinner, newModel.UserData, newModel.WaveSim, newModel.WaveSimSheet, newModel.UISheetTrail, newModel.Spinner, newModel.Sheet, newModel.IsLoading, newModel.LastChangeCheckTime, newModel.LastSimulatedCanvasState, newModel.LastDetailedSavedState, newModel.CurrentSelected, newModel.LastSelectedIds, newModel.LastUsedDialogWidth, newModel.SelectedComponent, newModel.CurrentStepSimulationStep, newModel.CurrentTruthTable, newModel.TTConfig, newModel.RightPaneTabVisible, newModel.SimSubTabVisible, newModel.CircuitCheck, newModel.Hilighted, newModel.Clipboard, newModel.LastCreatedComponent, newModel.SavedSheetIsOutOfDate, newModel.PendingDragAddition, newModel.DragPlacement, newModel.ProjectBrowser, newModel.TopSheetChoiceDeclined, newModel.ComponentLibraries, newModel.OpenLibrary, newModel.CatalogueSearch, newModel.ArrayCopiesTyped, newModel.SimulateInRenderer, newModel.SidecarSession, newModel.ProbeRead, newModel.SidecarInFlight, newModel.SidecarBuildEndedMs, newModel.SidecarRunEndedMs, newModel.StepRunTarget, newModel.FetchedData, newModel.FetchedStructure, newModel.FailedFetch, newModel.StimulusGeneration, newModel.CurrentViewport, newModel.ViewportChangedAtMs, newModel.WaveScrollSettling, newModel.WaveScrollSerial, newModel.ShowLibrarySheets, newModel.SuppressErrorPopups, newModel.OpenedLibrarySheets, newModel.ReadOnlyBaseline, matchValue_1, newModel.PopupViewFunc, newModel.SpinnerPayload, newModel.PopupDialogData, newModel.Notifications, newModel.TopMenuOpenState, newModel.SheetMenuPinned, newModel.DividerDragMode, newModel.WaveSimViewerWidth, newModel.ConnsOfSelectedWavesAreHighlighted, newModel.Pending, newModel.UIState, newModel.BuildVisible, newModel.CodeEditorState);
                        setupProjectFromComponents(true, name, saveCurrent ? updateLdCompsWithCompOpt((option = saveOpenFileAction(false, updatedModel, dispatch), (option != null) ? option[0] : undefined), project.LoadedComponents) : project.LoadedComponents, updatedModel, dispatch);
                    }
                    else {
                        toFail(printf("What? current project cannot be None at this point in openFileInProject"));
                    }
                }
            }
            else {
                throw new Exception("Match failure: Microsoft.FSharp.Core.FSharpOption`1");
            }
            break;
        }
    }
}

/**
 * Open a sheet of the project, SAVING the one being left if it has unsaved changes. That is what
 * every ordinary way of changing sheet goes through - the Sheets menu, following a custom
 * component into its sheet, and the waveform viewer's jump to a sheet.
 * 
 * Whether it has changes is worked out here rather than read off Model.SavedSheetIsOutOfDate: that
 * flag is only recomputed on DRAW BLOCK messages, so a change made by anything else - the
 * Properties pane setting a sheet's array settings, or its parameters - left it saying what was
 * true before the change, and the switch then dropped the edit. See
 * ModelHelpers.currentSheetIsOutOfDate.
 */
export function openFileInProject(name, project, model, dispatch) {
    openFileInProject$0027(currentSheetIsOutOfDate(model), name, project, model, dispatch);
}

export function removeAllCustomComps(name, project) {
    return map_3((lc) => {
        const patternInput = lc.CanvasState;
        const comps = patternInput[0];
        const idsToBeDeleted = map_3((comp_1) => comp_1.Id, filter_1((comp) => {
            const matchValue = comp.Type;
            let matchResult, c_1;
            if (matchValue.tag === 26) {
                if (matchValue.fields[0].Name === name) {
                    matchResult = 0;
                    c_1 = matchValue.fields[0];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return true;
                default:
                    return false;
            }
        }, comps));
        return new LoadedComponent(lc.Name, lc.TimeStamp, lc.FilePath, lc.WaveInfo, [filter_1((comp_2) => {
            const matchValue_1 = comp_2.Type;
            let matchResult_1, c_3;
            if (matchValue_1.tag === 26) {
                if (matchValue_1.fields[0].Name === name) {
                    matchResult_1 = 0;
                    c_3 = matchValue_1.fields[0];
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0:
                    return false;
                default:
                    return true;
            }
        }, comps), filter_1((conn) => {
            if (exists((id) => equals(id, conn.Source.HostId), idsToBeDeleted)) {
                return false;
            }
            else if (exists((id_1) => equals(id_1, conn.Target.HostId), idsToBeDeleted)) {
                return false;
            }
            else {
                return true;
            }
        }, patternInput[1])], lc.InputLabels, lc.OutputLabels, lc.LCParameterSlots, lc.Form, lc.LoadedComponentIsOutOfDate, lc.Description, lc.IsTopSheet, lc.ArrayInfo);
    }, project.LoadedComponents);
}

/**
 * Remove file.
 */
export function removeFileInProject(name, project, model, dispatch) {
    removeFileWithExtn(sheetExtension(project), project.ProjectPath, name);
    const newComponents = filter_1((lc) => (lc.Name.toLocaleLowerCase() !== name.toLocaleLowerCase()), project.LoadedComponents);
    const project$0027 = new Project(project.ProjectPath, project.OpenFileName, project.WorkingFileName, newComponents);
    const project$0027_1 = new Project(project$0027.ProjectPath, project$0027.OpenFileName, project$0027.WorkingFileName, removeAllCustomComps(name, project$0027));
    const matchValue = name === project.OpenFileName;
    if (isEmpty(newComponents)) {
        if (matchValue) {
            const newComponents_1 = singleton(createEmptyDiagramFile(project.ProjectPath, "main"));
            const project$0027_2 = new Project(project$0027_1.ProjectPath, "main", "main", newComponents_1);
            openFileInProject$0027(false, item_1(0, newComponents_1).Name, project$0027_2, model, dispatch);
        }
        else {
            toFail(printf("What? - this cannot happen"));
        }
    }
    else if (matchValue) {
        openFileInProject$0027(false, item_1(0, project$0027_1.LoadedComponents).Name, project$0027_1, model, dispatch);
    }
    else {
        openFileInProject$0027(false, project$0027_1.OpenFileName, project$0027_1, model, dispatch);
    }
    dispatch(Msg.FinishUICmd);
}

export function deleteFileConfirmationPopup(sheetName, model, dispatch) {
    let children;
    const project = value_5(model.CurrentProj);
    confirmationPopup("Delete sheet", "Delete", (children = ["Are you sure you want to delete the following design sheet?", react_1.createElement("br", {}), pathJoin([project.ProjectPath, sheetName + ".dgm"]), react_1.createElement("br", {}), "This action is irreversible."], react_1.createElement("div", {}, ...children)), () => {
        dispatch(new Msg(/* StartUICmd */ 109, [UICommandType.DeleteSheet]));
        dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_1, dispatch_1) => {
            removeFileInProject(sheetName, project, model_1, dispatch_1);
        }, dispatch]));
        dispatch(Msg.ClosePopup);
    }, dispatch);
}

export function getHintPaneElement(model) {
    const matchValue = model.Sheet.Wire.Symbol.HintPane;
    if (model.TopMenuOpenState.tag === 2) {
        return ofArray(["Click -> Open Sheet", react_1.createElement("br", {}), "Right-click -> Rename or Delete"]);
    }
    else if (matchValue != null) {
        const lst = concat_1(map_3((x) => ofArray([x, react_1.createElement("br", {})]), matchValue));
        if (length(lst) === 0) {
            return empty_1();
        }
        else {
            return getSlice(0, length(lst) - 2, lst);
        }
    }
    else {
        return singleton("");
    }
}

